import { Control, useController, useFieldArray } from 'react-hook-form';

import { CampaignAttributesSectionFormValues } from './types';
import {
  createMaxLengthValidator,
  createMinLengthValidator,
  createRequiredValidator,
  isOptionRequired,
  isValidInput,
} from '../../validators';

export const useControllers = (
  control: Control<
    CampaignAttributesSectionFormValues,
    any,
    CampaignAttributesSectionFormValues
  >,
  subscriberOptin: boolean,
  subscriberOptout: boolean,
  subscriberHelp: boolean,
  embeddedLink: boolean
) => {
  const {
    field: { value: optinKeywords, onChange: setOptinKeywords },
  } = useController({
    control,
    name: 'optinKeywords',
  });
  const {
    field: {
      value: optinMessage,
      onChange: setOptinMessage,
      onBlur: validateOptinMessage,
    },
    fieldState: { error: optinMessageError },
  } = useController({
    control,
    name: 'optinMessage',
    disabled: !subscriberOptin,
    rules: {
      validate: {
        isValidInput,
        withValidMinLength: createMinLengthValidator(20, true),
        withValidMaxLength: createMaxLengthValidator(1024, true),
      },
    },
  });
  const {
    field: { value: optoutKeywords, onChange: setOptoutKeywords },
  } = useController({
    control,
    name: 'optoutKeywords',
  });
  const {
    field: {
      value: optoutMessage,
      onChange: setOptoutMessage,
      onBlur: validateOptoutMessage,
    },
    fieldState: { error: optoutMessageError },
  } = useController({
    control,
    name: 'optoutMessage',
    disabled: !subscriberOptout,
    rules: {
      validate: {
        isValidInput,
        isRequired: createRequiredValidator('Please enter message'),
        withValidMinLength: createMinLengthValidator(20),
        withValidMaxLength: createMaxLengthValidator(1024),
      },
    },
  });
  const {
    field: { value: helpKeywords, onChange: setHelpKeywords },
  } = useController({
    control,
    name: 'helpKeywords',
  });
  const {
    field: {
      value: helpMessage,
      onChange: setHelpMessage,
      onBlur: validateHelpMessage,
    },
    fieldState: { error: helpMessageError },
  } = useController({
    control,
    name: 'helpMessage',
    disabled: !subscriberHelp,
    rules: {
      validate: {
        isValidInput,
        isRequired: createRequiredValidator('Please enter message'),
        withValidMinLength: createMinLengthValidator(20),
        withValidMaxLength: createMaxLengthValidator(1024),
      },
    },
  });
  const {
    field: {
      value: embeddedLinkSample,
      onChange: setEmbeddedLinkSample,
      onBlur: validateEmbeddedLinkSample,
    },
    fieldState: { error: embeddedLinkSampleError },
  } = useController({
    control,
    name: 'embeddedLinkSample',
    disabled: !embeddedLink,
    rules: {
      validate: {
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(255),
      },
    },
  });

  return {
    optinKeywords,
    setOptinKeywords,
    optinMessage,
    setOptinMessage,
    validateOptinMessage,
    optinMessageError,
    optoutKeywords,
    setOptoutKeywords,
    optoutMessage,
    setOptoutMessage,
    validateOptoutMessage,
    optoutMessageError,
    helpKeywords,
    setHelpKeywords,
    helpMessage,
    setHelpMessage,
    validateHelpMessage,
    helpMessageError,
    embeddedLinkSample,
    embeddedLinkSampleError,
    setEmbeddedLinkSample,
    validateEmbeddedLinkSample,
  };
};
